<template>
    <transition name="plainToast">
        <div class="plain-dialog" v-show="show_dialog">
            <i :class="[{'dialog-icon': type !== undefined}, {['dialog-icon-' + getDialogType()]: true}]"></i>
            {{text}}
            <span v-html="richText" v-if="richText"></span>
        </div>
    </transition>
</template>
<script>
    import API from '../js/api';
    export default {
        data: function () {
            return {
                show_dialog: false,
                text: '',
                richText: '',
                type: undefined, // dialog类型，1成功提示, 0警告提示，-1失败提示
                duration: 1000
            }
        },
        computed: {
            plain_dialog_class(){
                return !this.show_dialog ? 'plain-dialog' : 'plain-dialog toastAnimate';
            }
        },
        methods: {
            getDialogType() {
                var type;

                switch(this.type) {
                    case -1: 
                        type = 'error';
                        break;
                    case 0:
                        type = 'warn';
                        break;
                    case 1:
                        type = "succ";
                        break;
                    default:
                        type = '';
                }
                
                return type;
            },
            hide(){
                this.show_dialog = false;
            },
            show(){
                this.show_dialog = true;
            },
            /**
             * 配置项
             * text : 文本内容
             * type : 默认为1，成功 
             * cal : 执行完成的回调
             * duration : 展示toast的时间
             */
             dialog(input){
                let that = this;
                let _input = input || {};
                that.text = _input.text || '操作成功';//赋值
                that.richText = _input.richText || '' //富文本(如链接)
                that.type = _input.type;
                that.duration = _input.duration || 1000;
                that.show_dialog = true;
                setTimeout(function () {
                    that.show_dialog = false;
                    if (typeof _input.cal === 'function') {
                        _input.cal();
                    }
                }, that.duration);
            }


        },
        mounted: function () {
            var that = this;
            API.register("toast", function (params, cal) {
                that.dialog(params);
                if (typeof cal === 'function') cal();
            });
        },
        components: {}
    }
</script>
<style lang="less" rel="stylesheet/less">
    .plain-dialog {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 1024;
        min-width: 180px;
        min-height: 70px;
        line-height: 70px;
        padding: 10px 40px;
        transform: translate(-50%);
        background: rgba(63, 65, 71, 0.93);
        border-radius: 2px;
        color: #ffffff;
        font-size: 30px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.9;

        .dialog-icon {
            display: inline-block;
            width: 45px;
            height: 45px;
            margin-top: -6px; /*no*/
            margin-right: 5px;
            vertical-align: middle;
        }
        .dialog-icon-succ {
            background: url("../less/images/a399y-5oohv.png") no-repeat center;
            background-size: 100%;
            margin-top: -1px;
        }
        .dialog-icon-warn {
            background: url("../less/images/aavqz-9pz9p.png") no-repeat center;
            background-size: 100%;
            margin-top: -1px;
        }
        .dialog-icon-error {
            background: url("../less/images/aavqz-9pz9p.png") no-repeat center;
            background-size: 100%;
            margin-top: -1px;
        }
    }

    .plainToast-enter-active, .plainToast-leave-active {
        transition: opacity 1s;
    }

    .plainToast-enter {
        opacity: 0.93;
    }

    .plainToast-leave-active {
        opacity: 0;
    }
</style>